/* global FWP, jQuery */

import $ from 'jquery';
import Swiper from 'Swiper';

class HomePage {
    constructor() {
        $(document).ready(() => {
            // check that we are on the homepage
            if ($('.c-home-page').length) {
                this.init();
            }
        })
    }

    init() {
        this.initCalcSlider();
        this.initPostsSlider();
        this.initVerticalSliders();
    }

    /**
     * Calculators slider
     */
    initCalcSlider() {
        this.calcSlider = {
            $container: $('.c-home-page__calculators-swiper-container.swiper-container'),
            $wrapper  : $('.c-home-page__calculators-swiper-wrapper.swiper-wrapper'),
            $items    : $('.c-home-page__calculators-swiper-item.swiper-slide')
        };
        if (this.validateCalcSlider()) {
            // this.calculateWrapper();
            this.calcSlider.$container.show(100, () => {
                this.initCalcSwiper();
                this.initCalcControls();
            });

        }

    }

    validateCalcSlider() {
        return this.calcSlider && this.calcSlider.$container.length == 1 && this.calcSlider.$wrapper.length == 1 && this.calcSlider.$items.length > 0;
    }

    calculateWrapper() {
        //we want 3 items per column
        let columns = Math.floor(this.calcSlider.$items.length / 3);
        let width = this.calcSlider.$items.eq(0).width();
        //set the width to the wrapper
        this.calcSlider.$wrapper.width(width * columns);
    }

    initCalcSwiper() {
        this.calcSlider.Swiper = new Swiper(this.calcSlider.$container[0], {
            setWrapperSize : true,
            initialSlide   : 0,
            slidesPerColumn: 5,
            slidesPerView  : 4,
            spaceBetween   : 0,
            breakpoints    : {

                // when window width is <= 768
                768 : {
                    slidesPerColumn: 4,
                    slidesPerView  : 1,
                }, // when window width is <= 768
                1300: {
                    slidesPerView: 3,
                },
            }
        });
    }

    initCalcControls() {
        $('.js-calc-slider-buttons .js-arrow-button-left').click(() => {
            this.calcSlider.Swiper.slidePrev()
        });
        $('.js-calc-slider-buttons .js-arrow-button-right').click(() => {
            this.calcSlider.Swiper.slideNext()
        });
    }

    /**
     * Posts slider
     */
    initPostsSlider() {
        this.postsSlider = {
            $container: $('.c-home-page__posts-swiper-container.swiper-container'),
            $wrapper  : $('.c-home-page__posts-swiper-wrapper.swiper-wrapper'),
            $items    : $('.c-home-page__posts-swiper-item.swiper-slide')
        };
        if (this.validatePostsSlider()) {
            this.postsSlider.$container.show(100, () => {
                this.initPostsSwiper();
                this.initPostsControls();
            });

        }

    }

    validatePostsSlider() {
        return this.postsSlider && this.postsSlider.$container.length == 1 && this.postsSlider.$wrapper.length == 1 && this.postsSlider.$items.length > 0;
    }

    initPostsSwiper() {
        this.postsSlider.Swiper = new Swiper(this.postsSlider.$container[0], {
            setWrapperSize: true,
            initialSlide  : 0,
            slidesPerView : 3,
            spaceBetween  : 0,
            breakpoints   : {

                // when window width is <= 768
                768 : {
                    slidesPerView: 1,
                }, // when window width is <= 768
                1300: {
                    slidesPerView: 2,
                },
            }
        });
    }

    initPostsControls() {
        $('.js-posts-slider-buttons .js-arrow-button-left').click(() => {
            this.postsSlider.Swiper.slidePrev()
        });
        $('.js-posts-slider-buttons .js-arrow-button-right').click(() => {
            this.postsSlider.Swiper.slideNext()
        });
    }

    /**
     * Vertical sliders
     */
    initVerticalSliders() {
        this.verticalSliders = {
            background: $('.js-join-background'),
            headings  : {
                slider    : null,
                $container: $('.c-home-page__join-headings-slider-container.swiper-container'),
                $wrapper  : $('.c-home-page__join-headings-slider-wrapper.swiper-wrapper'),
                $items    : $('.c-home-page__join-headings-slider-item.swiper-slide'),
            },
            texts     : {
                slider    : null,
                $container: $('.c-home-page__join-text-slider-container.swiper-container'),
                $wrapper  : $('.c-home-page__join-text-slider-wrapper.swiper-wrapper'),
                $items    : $('.c-home-page__join-text-slider-item.swiper-slide'),
            }
        };
        if (this.validateVerticalSliders()) {
            this.initVerticalSwipers();
            this.initVerticalControls();
        }
    }

    validateVerticalSliders() {
        return this.verticalSliders.headings.$container.length != 0 && this.verticalSliders.headings.$wrapper.length != 0 && this.verticalSliders.headings.$items.length > 0 && this.verticalSliders.texts.$container.length != 0 && this.verticalSliders.texts.$wrapper.length != 0 && this.verticalSliders.texts.$items.length > 0;
    }

    initVerticalSwipers() {
        let opts = {
            direction     : 'vertical',
            initialSlide  : this.verticalSliders.headings.$items.length - 1,
            slidesPerView : 1,
            autoHeight    : true,
            height        : 60,
            spaceBetween  : 30,
            allowTouchMove: false,
            speed         : 500

        };

        //init headings swiper
        this.verticalSliders.headings.slider = new Swiper(this.verticalSliders.headings.$container[0], opts);
        this.verticalSliders.headings.slider.on('slideChange', this.updateHeadingSlideClasses.bind(this));
        opts.initialSlide = 0;
        //init text swiper
        this.verticalSliders.texts.slider = new Swiper(this.verticalSliders.texts.$container[0], opts);
        this.verticalSliders.texts.slider.on('slideChange', this.updateTextSlideClasses.bind(this));

    }

    initVerticalControls() {
        $('.js-join-slider-buttons .js-arrow-button-left').click((e) => {
            this.verticalSliders.headings.slider.slideNext();
            this.verticalSliders.texts.slider.slidePrev();
            this.updateBackgroundPosition();
        });
        $('.js-join-slider-buttons .js-arrow-button-right').click((e) => {
            this.verticalSliders.headings.slider.slidePrev();
            this.verticalSliders.texts.slider.slideNext();
            this.updateBackgroundPosition();
        });
    }

    updateBackgroundPosition() {
        let deg = this.verticalSliders.texts.slider.activeIndex * 30;
        this.verticalSliders.background.css('transform', 'translate(-50%, -50%) rotate(' + deg + 'deg)');
    }

    updateHeadingSlideClasses() {
        let cl = 'slide-past';
        this.verticalSliders.headings.$items.removeClass(cl);
        let currHead = this.verticalSliders.headings.slider.activeIndex;

        this.verticalSliders.headings.$items.each((ind, el) => {
            if (ind >= currHead) {
                $(el).addClass(cl)
            }
        });


    }

    updateTextSlideClasses() {
        let cl = 'slide-past';
        this.verticalSliders.texts.$items.removeClass(cl);
        let currText = this.verticalSliders.texts.slider.activeIndex;

        this.verticalSliders.texts.$items.each((ind, el) => {
            if (ind < currText) {
                $(el).addClass(cl)
            }
        });
    }
}

export default HomePage;
